import { GetServerSideProps } from 'next'

import { tagMap } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'

import CommandersPage from '.'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const dir = context.resolvedUrl.startsWith('/cards') ? 'cards' : 'commanders'
  const slug = context.query.slug as string[]

  let url
  if (context.query.f && context.params?.slug) {
    // Deck filters
    const params = {
      cmdr: slug[0],
      dir: 'commanders',
      f: context.query.f as string,
    }
    const queryString = new URLSearchParams(params).toString()
    url = `${process.env.NEXT_PUBLIC_EDHREC_API_URL}/filters/?${queryString}`
  } else {
    const cardName = slug[0]
    const subDirs = slug.slice(1).map((slug: string) => (slug in tagMap ? tagMap[slug as keyof typeof tagMap] : slug))
    const resolvedUrl = subDirs.length > 0 ? `${cardName}/${subDirs.join('/')}` : cardName
    url = `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL_CLOUDFLARE}/pages/${dir}/${resolvedUrl}.json`
  }

  return serverSidePropsFor(url, context.req.headers)
}

export default CommandersPage
